import { Component, OnInit } from "@angular/core";
import { slider } from "../animation";
import { RouterOutlet } from "@angular/router";
import { DatastorageService } from "../datastorage.service";
import { Step } from "../core/step.model";

@Component({
  selector: "app-addpolicy",
  templateUrl: "./addpolicy.component.html",
  styleUrls: ["./addpolicy.component.css"],
  animations: [slider],
  standalone: false
})
export class AddpolicyComponent implements OnInit {
  multiSteps = [
    { name: "Vehicle Details", completed: false },
    { name: "Customer Details", completed: false },
    { name: "Plan Details", completed: false },
    { name: "Payment Details", completed: false },
    { name: "Download Policy", completed: false },
  ];

  constructor(private dataService: DatastorageService) { }

  ngOnInit(): void {
    this.dataService.nextClick.subscribe((step: Step) => {
      this.completeStep(step);
    });
  }

  completeStep(step: Step): void {
    if (step != null && step.stepNumber >= 0 && step.stepNumber < this.multiSteps.length) {
      // Defer update to avoid ExpressionChangedAfterItHasBeenCheckedError
      setTimeout(() => {
        this.multiSteps[step.stepNumber].completed = step.completed;
      });
    }
  }

  resetStepper() {
    this.multiSteps.forEach(step => step.completed = false);
  }

  prepareRoute(outlet: RouterOutlet): string | null {
    if (outlet.activatedRouteData["animation"] === 'vehicle') {
      this.resetStepper();
    }
    return (
      outlet &&
      outlet.activatedRouteData &&
      outlet.activatedRouteData["animation"]
    );
  }
}
